import React from "react";
import StatusPage from "./views/StatusPage";
import { StatusContextProvider } from "./StatusView";

const StatusView = () => {
  return (
    <StatusContextProvider>
      <StatusPage />
    </StatusContextProvider>
  );
};
export default StatusView;
